export function transformConstant(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  const governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field

  // flag that the constant was autopopulated by the system
  valueObj.metadata = valueObj.metadata || {}
  valueObj.metadata.autoPopulated = true

  // set the cell value
  return governanceOwner.constant_value
}
